import React from 'react'
import PropTypes from 'prop-types'
import { TweenMax } from 'gsap'

class FancyToggle extends React.Component {
    componentDidMount () {
        this.setValue(this.props.value)
    }

    componentDidUpdate (prevProps) {
        if (prevProps.value !== this.props.value && this.props.value !== undefined) {
            this.setValue(this.props.value)
        }
    }

    handleClick (event, value) {
        event.preventDefault()
        const convertedValue = this.props.numericValue ? (value ? 1 : 0) : value
        this.setValue(convertedValue)
    }

    setValue (value) {
        const convertedValue = this.props.numericValue ? (value === true || value === 1 ? 1 : 0) : value
        this.props.handleChange({
            [this.props.name]: convertedValue
        }, this.animate.bind(this))
    }

    animate () {
        if (this.props.value === true || this.props.value === 1) {
            TweenMax.to(this.slider, 0.2, { x: '-100%' })
        } else {
            TweenMax.to(this.slider, 0.2, { x: '0%' })
        }
    }

    render () {
        const isActive = this.props.numericValue ? this.props.value === 1 : this.props.value === true
        return (
            <div className={`fancy-toggle ${this.props.className}`}>
                <div className='form-control my-4 my-md-3'>
                    {this.props.title ? <label dangerouslySetInnerHTML={{ __html: this.props.title }} /> : ''}
                    <div className='d-flex align-items-center toggle-box'>
                        <div className='toggle'>
                            <div className='toggle-slider' ref={el => this.slider = el} />
                            <a href='#' className={`toggle-item ${isActive ? 'active' : ''}`} onClick={event => this.handleClick(event, true)}>
                                {this.props.titleYes}
                            </a>
                            <a href='#' className={`toggle-item ${!isActive ? 'active' : ''}`} onClick={event => this.handleClick(event, false)}>
                                {this.props.titleNo}
                            </a>
                        </div>
                        {this.props.children}
                    </div>
                </div>
            </div>
        )
    }
}

FancyToggle.propTypes = {
    titleYes: PropTypes.string,
    titleNo: PropTypes.string,
    title: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
    handleChange: PropTypes.func,
    numericValue: PropTypes.bool
}

FancyToggle.defaultProps = {
    titleYes: 'Yes',
    titleNo: 'No',
    value: false,
    numericValue: false
}

export default FancyToggle



// WEBPACK FOOTER //
// ./resources/js/elements/FancyToggle.js